import WykonanieGodzinne from './WykonanieGodzinne';
export default WykonanieGodzinne;